import React, { useEffect, useState } from 'react'
import { Form } from "react-bootstrap";
import { FiCheckCircle, FiDownload, FiFileText, FiUploadCloud, FiLock, FiSend } from "react-icons/fi";
import { ToastContainer, toast } from 'react-toastify';
import TdsDialoge from "../../../../../../../components/Dialog/tdsDialoge"
import { Check, Cross, Pause, PencilLine } from '../../../../../../../components/icons/Icons';
import { useDispatch } from 'react-redux';
import { useSelect } from '../../../../../../../services/commonServices';
import { tdsRequestFormPath } from '../../../../../../../services/config';
import { initStatusState, saveTdsStatusData } from '../../../../../../../redux/slices/tdsSlice';

const RightSidebar = ({ staffId, reviewTdsDeclaration, haldleChangeOldNewRegime }) => {

    const currentUser = JSON.parse(localStorage.getItem("tdsUser") || "{}")?.staffId || ""

    const [isRequestEdit, setIsRequestEdit] = useState(false)
    const [isApproved, setIsApproved] = useState(false)
    const [isHold, setIsHold] = useState(false)
    const [isRejected, setIsRejected] = useState(false)

    const [quickPresets, setQuickPresets] = useState("3 days")

    const user = JSON.parse(localStorage.getItem("user_data")) || {}
    const tdsStore = useSelect("tds")
    const dispatch = useDispatch()

    const [updateStatus, setUpdateStatus] = useState({
        userId: user.user_id,
        staffId: staffId,
        status: "1"
    })

    const [issuesToAddress, setIssuesToAddress] = useState([])

    const handleAddress = ({ target: { checked, value } }) => {
        setIssuesToAddress((prev) => {
            if (checked) {
                return [...prev, value];
            } else {
                const updated = prev.filter((v) => v !== value);
                return updated;
            }
        });
    };

    const submitStatus = (e) => {
        e.preventDefault()
        const formData = {
            path: tdsRequestFormPath,
            data: {
                ...updateStatus,
                form12bAddressType: issuesToAddress.toString(),
            }
        }
        dispatch(saveTdsStatusData(formData))
    }

    useEffect(() => {
        if (tdsStore.tdsStatusSuccess) {
            toast.success(tdsStore.tdsStatusMessage)
            dispatch(initStatusState())
        }
        if (tdsStore.tdsStatusError) {
            toast.error(tdsStore.tdsStatusMessage)
            dispatch(initStatusState())
        }
    }, [tdsStore])

    const SmartCheck = ({ color, label, amount, tooltip }) => (
        <div className={`erd-smart ${color}`} title={tooltip || label}>
            <div className="erd-smart-left">
                <span className="erd-dot" />
                <span className="erd-smart-text color-white font-weight-200" style={{ whiteSpace: 'nowrap' }}>
                    {label}
                </span>
            </div>
            <div className="erd-smart-right">
                {amount ? <span className="erd-amt">{amount}</span> : <FiCheckCircle />}
            </div>
        </div>
    );

    const closeApproveDialog = () => {
        setIsApproved(false)
    }
    
    const closeRequestEditDialog = () => {
        setIsRequestEdit(false)
    }
    
    const submitRequestEditForm = () => { }
    
    const closeHoldDialog = () => {
        setIsHold(false)
    }
    
    const submitHoldForm = () => { }
    
    const closeRejectDialog = () => {
        setIsRejected(false)
    }
    
    const submitRejectForm = () => { }

    return (
        <div className="erd-rightbar">
            <div className="erd-right-inner">
                {/* Smart Checks Panel */}
                <div className="erd-panel">
                    <div className="erd-panel-h text-purple font-weight-200">Smart Checks</div>
                    <div className="smart-checks-container">
                        <SmartCheck color="g" label="HRA Formula" tooltip="HRA Formula Check" />
                        <SmartCheck color="b" label="Landlord PAN" tooltip="Landlord PAN Validation" />
                        <SmartCheck color="g" label="87A Rebate" tooltip="Section 87A Rebate" />
                        <SmartCheck color="y" label="Proof Sufficiency" tooltip="Proof Sufficiency Check" />
                        <SmartCheck color="o" label="TDS Delta" amount="₹2.3k" tooltip="TDS Delta Amount" />
                    </div>
                </div>

                {/* Quick Actions Panel */}
                <div className="erd-panel">
                    <div className="erd-panel-h text-purple font-weight-200">Quick Actions</div>
                    <div className="d-grid gap-2">
                        <button 
                            style={{ height: "40px" }} 
                            className="d-flex align-items-center justify-content-center gap-2 universal-btn-green border-radius-8px g" 
                            onClick={() => setIsApproved(true)}
                        > 
                            <Check /> <span>Approve (A)</span>
                        </button>
                        <button 
                            style={{ height: "40px" }} 
                            className="d-flex align-items-center justify-content-center gap-2 universal-btn-yellow border-radius-8px o" 
                            onClick={() => setIsRequestEdit(true)}
                        > 
                            <PencilLine /> <span>Request Edit (R)</span>
                        </button>
                        <button 
                            style={{ height: "40px" }} 
                            className="d-flex align-items-center justify-content-center gap-2 universal-btn-info border-radius-8px y" 
                            onClick={() => setIsHold(true)}
                        > 
                            <Pause /> <span>Put On Hold (H)</span>
                        </button>
                        <button 
                            style={{ height: "40px" }} 
                            className="d-flex align-items-center justify-content-center gap-2 universal-btn-red border-radius-8px r" 
                            onClick={() => setIsRejected(true)}
                        > 
                            <Cross /> <span>Reject</span>
                        </button>
                    </div>
                </div>

                {/* Request from Employee Panel */}
                <div className="erd-panel">
                    <div className="erd-panel-h text-purple font-weight-200">Request from Employee</div>
                    <div className="erd-checks">
                        {[
                            { value: 1, label: 'Landlord PAN' },
                            { value: 2, label: 'Missing Receipts' },
                            { value: 3, label: 'Insurance Certificate' },
                            { value: 4, label: 'Clarify Amount' }
                        ].map((item) => (
                            <Form.Check
                                key={item.value}
                                value={item.value}
                                type="checkbox"
                                label={item.label}
                                className='color-white font-weight-200 mb-2'
                                onChange={handleAddress}
                            />
                        ))}
                    </div>
                    <button 
                        className="erd-btn border-radius-8px universal-btn p w-100 mt-2" 
                        onClick={submitStatus}
                    >
                        <FiSend /> <span>Send Request</span>
                    </button>
                </div>

                {/* Finalize Panel */}
                <div className="erd-panel">
                    <div className="erd-panel-h text-purple font-weight-200">Finalize</div>
                    <div className="d-grid gap-2">
                        <button className="erd-btn border-radius-8px p universal-btn">
                            <FiLock /> <span>Lock & Push to Payroll</span>
                        </button>
                        <button className="erd-btn border-radius-8px p universal-sec-btn">
                            <FiUploadCloud /> <span>Attach Form 16</span>
                        </button>
                        <button className="erd-btn border-radius-8px universal-sec-btn outline r">
                            <span>Re-issue Form 16</span>
                        </button>
                    </div>
                </div>

                {/* Export Options Panel */}
                <div className="erd-panel">
                    <div className="erd-panel-h text-purple font-weight-200">Export Options</div>
                    <div className="d-grid gap-2">
                        <button className="erd-btn border-radius-8px p universal-sec-btn">
                            <FiDownload /> <span>Download 12BB PDF</span>
                        </button>
                        <button className="erd-btn border-radius-8px p universal-sec-btn">
                            <FiFileText /> <span>Export Calc Sheet</span>
                        </button>
                    </div>
                </div>

                {/* Keyboard Shortcuts Panel */}
                <div className="erd-panel">
                    <div className="erd-panel-h text-purple font-weight-200">Keyboard Shortcuts</div>
                    <ul className="erd-short color-white font-weight-200">
                        <li><strong>A</strong> - Approve</li>
                        <li><strong>R</strong> - Request Edit</li>
                        <li><strong>H</strong> - Hold</li>
                        <li><strong>V</strong> - Verify</li>
                        <li><strong>T</strong> - Recalculate</li>
                    </ul>
                </div>
            </div>

            <TdsDialoge
                staffId={staffId}
                isApproved={isApproved}
                closeApproveDialog={closeApproveDialog}
                isRequestEdit={isRequestEdit}
                closeRequestEditDialog={closeRequestEditDialog}
                submitRequestEditForm={submitRequestEditForm}
                quickPresets={quickPresets}
                setQuickPresets={setQuickPresets}
                isHold={isHold}
                closeHoldDialog={closeHoldDialog}
                submitHoldForm={submitHoldForm}
                isRejected={isRejected}
                closeRejectDialog={closeRejectDialog}
                submitRejectForm={submitRejectForm}
            />

            <ToastContainer />
        </div>
    )
}

export default RightSidebar